<template>
  <el-row :gutter="20" class="sec_box d2-mt-10" v-loading="loading">
    <template v-if="readData.length != 0">
      <el-col
        :span="24"
        v-for="(item, index) in readData"
        :key="index"
        class="list_item_box"
        :title="item.Title"
      >
        <img :src="item.CoverImg" />
        <div class="list_item_info" @click="listDetialHandle(item)">
          <p class="list_item_title">{{ item.Title || "-" }}</p>
          <span class="list_item_time"
            ><i class="el-icon-time"></i>{{ item.ReleaseTime || "-" }}</span
          >
          <span class="list_item_intro">{{ item.Abstract || "" }}</span>
        </div>
        <div class="align-right">
          <div :class="['list_item_circle', item.isRead ? '' : 'active']"></div>
        </div>
      </el-col>
      <el-col :span="24" class="align-center mt-20">
        <span class="no_more">没有更多了~</span>
      </el-col>
    </template>
    <template v-else>
      <el-empty></el-empty>
    </template>
  </el-row>
</template>

<script>
import * as indexService from "@/api/sys/index";
export default {
  name: "listPicture",
  data() {
    return {
      listDetialData: {},
      listDetialVisible: false,
    };
  },
  props: {
    code: {
      type: String,
      required: false,
      default: "",
    },
    ListData: {
      type: Array,
      required: false,
      default: () => [],
    },
    readData: {
      type: Array,
      required: false,
      default: () => [],
    },
    total: {
      type: Number,
      required: false,
      default: 0,
    },
    loading: {
      type: Boolean,
      required: false,
      default: false,
    },
  },
  created() {},
  mounted() {},
  methods: {
    listDetialHandle(item) {
      console.log(item);
      if (!item.isRead) {
        let configID = {
          configID: item.configID,
        };
        indexService.IsReadListData(configID).then((data) => {});
      }
      this.$router.push({
        path: "webView",
        query: {
          code: "comment",
          shortTitle: item.Type,
          detailed: false,
          dataId: item.ID,
          fiter: "",
        },
      });
    },
  },
};
</script>

<style lang="scss" scoped>
@import "~@/assets/style/style.css";
@import "~@/assets/style/richText.scss";
</style>